import { render, staticRenderFns } from "./BreakdownModal.vue?vue&type=template&id=083982d1"
import script from "./BreakdownModal.vue?vue&type=script&lang=js"
export * from "./BreakdownModal.vue?vue&type=script&lang=js"
import style0 from "./BreakdownModal.vue?vue&type=style&index=0&id=083982d1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports